import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  site_type: 'event_based',
  event_name: 'product_impression',
  event_category: 'ecommerce',
  event_action: 'view_item_list',
  event_label: 'product recommendations',
  product_impression_list: null, // '<impression list name>'
  product_impression_position: null, // '<product position>'
  rec_ai_placement_id: null // '<placement_id of recommendation carousel>'
};

function trackAIRecommendedProducts(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};
  eventData.product_impression_id?.forEach(function (_, index: number) {
    eventData.product_impression_position.push(index + 1);
    eventData.product_impression_list.push(location.pathname);
  });
  eventData.rec_ai_placement_id = data.placement_id;
  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('getRecAIProdData', trackAIRecommendedProducts);
